import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AboutBrand from "./pages/AboutBrand"; // Import new page
// import About from "./components/About";
import Products from "./components/Products";
import Pineapple from "./pages/Pineapple.js";
import Cans from "./pages/Cans.js";
import Olive from "./pages/Olive.js";
import Tuna from "./pages/Tuna.js";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import ContactForm from './components/ContactForm'; 
import Sprats from "./pages/Sprats";
import Atlantic from "./pages/Atlantic";
import Tomato from "./pages/Tomato";
import Liver from "./pages/Liver";
import Juise from "./pages/Juise";

import Canned from "./pages/Canned";


// import Footer from "./components/Footer";

function App() {
  const isProduction = process.env.NODE_ENV === "production";

  console.log(`🚀 Running in ${isProduction ? "production" : "development"} mode!`);

  return (
    <Router>
      <div className="App">
        <Navbar />
        <div style={{ padding: "00px" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-brand" element={<AboutBrand />} />
            {/* <Route path="/about" element={<About />} /> */}
            <Route path="/products" element={<Products />} />
            <Route path="/products/pineapple" element={<Pineapple />} />
            <Route path="/cans" element={<Cans />} />
            <Route path="/products/olive" element={<Olive />} />
            <Route path="/products/tuna" element={<Tuna />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact-us" element={<ContactForm />} />
            <Route path="/products/canned/sprats" element={<Sprats />} />
            <Route path="/products/canned/atlantic" element={<Atlantic />} />
            <Route path="/products/canned/tomato" element={<Tomato />} />
            <Route path="/products/canned/liver" element={<Liver />} />
            <Route path="/products/canned" element={<Canned />} />
            <Route path="/products/juise" element={<Juise />} />

          </Routes>
        </div>
        
        {/* Show debug-information only in development-mode */}
        {/* {!isProduction && (
          <div style={{ background: "#ffcc00", padding: "10px", textAlign: "center" }}>
            ⚠️ Dev Mode: Debug information is visible
          </div>
        )} */}

        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
